document.addEventListener("DOMContentLoaded", function () {
  const tabItems = document.querySelectorAll(".tab-collections li");
  const shopAllButton = document.querySelector(".shop-all-button");

  tabItems.forEach(function (item) {
    item.addEventListener("click", function () {
      const collectionUrl = item.dataset.collectionUrl;

      if (collectionUrl && shopAllButton) {
        shopAllButton.setAttribute("href", collectionUrl);
      }
    });
  });
});

// contact form js

document.addEventListener("DOMContentLoaded", function () {
  const disclaimer = document.querySelector(".disclaimer_text");
  if (!disclaimer) {
    return;
  }
  const contactSection = document.querySelector(".contact-us-section");
  function checkCurrentStep(target) {
    const step = target.getAttribute("data-current-step");
    if (step === "success") {
      disclaimer.style.display = "none";
      addSuccessIcon(target);
      if (contactSection) {
        contactSection.style.padding = "0"; // remove any existing padding shorthand
        contactSection.style.paddingTop = "60px"; // add new top padding
      }
    } else {
      disclaimer.style.display = "";
    }
  }

  function addSuccessIcon(target) {
    const shadowRoot = document.querySelector(
      "form-embed#app-embed"
    )?.shadowRoot;
    if (!shadowRoot) return;

    const heading = shadowRoot.querySelector("h2._formBannerHeading_z5ku3_9");
    if (!heading || shadowRoot.querySelector(".custom-success-icon")) return; // prevent duplicates

    const img = document.createElement("img");
    img.src = "https://cdn-icons-png.flaticon.com/512/845/845646.png"; // 🖼️ replace with your real image URL
    img.alt = "Success";
    img.className = "custom-success-icon";
    img.style.width = "25px";
    img.style.height = "25px";
    img.style.marginRight = "6px";
    img.style.verticalAlign = "middle";

    heading.prepend(img);
  }

  function watchInsideShadow() {
    const formEmbed = document.querySelector("form-embed#app-embed");
    if (!formEmbed) {
      return;
    }

    const shadowRoot = formEmbed.shadowRoot;
    if (!shadowRoot) {
      return;
    }

    const target = shadowRoot.querySelector("div#app-embed");
    if (!target) {
      return;
    }

    // Watch for attribute changes
    const observer = new MutationObserver(() => checkCurrentStep(target));
    observer.observe(target, {
      attributes: true,
      attributeFilter: ["data-current-step"],
    });

    // Also poll every 500ms in case observer fails
    const pollInterval = setInterval(() => {
      if (target.getAttribute("data-current-step") === "success") {
        checkCurrentStep(target);
        clearInterval(pollInterval); // Stop polling
      }
    }, 500);

    // Initial check
    checkCurrentStep(target);
  }

  // Wait until form-embed is in the DOM
  const wait = setInterval(() => {
    if (document.querySelector("form-embed#app-embed")) {
      clearInterval(wait);
      setTimeout(watchInsideShadow, 300); // slight delay to ensure shadow DOM is ready
    }
  }, 200);
});

document.addEventListener('DOMContentLoaded', () => {
  const desc = document.querySelector('.product-description.product__description');
  
  if (desc) {
    desc.innerHTML = desc.innerHTML
      .replace(/(^|<br\s*\/?>|\n|\r)\s*•\s*/g, '$1');
  }
});
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".metafield-rich_text_field li").forEach(function(li) {
    // Trim text and check if it's empty or just a bullet symbol
    const text = li.textContent.replace(/•/g, "").trim();
    if (!text) li.remove();
  });
});
document.querySelectorAll('.specification-box .metafield-rich_text_field p:first-child').forEach(p => {
    const html = p.innerHTML;
    const firstBrIndex = html.indexOf('<br');

    if (firstBrIndex > -1) {
      const beforeBr = html.substring(0, firstBrIndex).trim();
      const afterBr = html.substring(html.indexOf('>', firstBrIndex) + 1).trim();

      p.innerHTML = `<h4>${beforeBr}</h4> ${afterBr}`;
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-category-desc ul li").forEach(function (li) {
    li.innerHTML = li.innerHTML.replace(/^✔\s*/, '');
  });
});

  $("#mainmenu").prepend(
  '<a href="#" id="menu" class="menulines-button" aria-label="Open menu">' +
    '<span class="menulines"></span>' +
  '</a>'
);






